module.exports = __webpack_public_path__ + "static/media/storyLike.ecea59e2.svg";